module.exports = __webpack_public_path__ + "img/icon_star_gray.1584485f.png";